<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M3 20.9999V17.2499L14.06 6.18994L17.81 9.93994L6.75 20.9999H3ZM5 18.9999H5.92L14.98 9.93994L14.06 9.01994L5 18.0799V18.9999Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path d="M20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3C17.4 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
